import { __decorate, __metadata } from "tslib";
import { SerializableMember, SerializableObject } from '@openhps/core';
import { CameraObject } from './CameraObject';
let PerspectiveCameraObject = class PerspectiveCameraObject extends CameraObject {
    constructor(uid, displayName, width, height, fov = 50, near = 0.1, far = 2000) {
        super(uid, displayName, width, height);
        this.fov = fov;
        this.near = near;
        this.far = far;
    }
};
__decorate([
    SerializableMember(),
    __metadata("design:type", Number)
], PerspectiveCameraObject.prototype, "fov", void 0);
__decorate([
    SerializableMember(),
    __metadata("design:type", Number)
], PerspectiveCameraObject.prototype, "near", void 0);
__decorate([
    SerializableMember(),
    __metadata("design:type", Number)
], PerspectiveCameraObject.prototype, "far", void 0);
PerspectiveCameraObject = __decorate([
    SerializableObject(),
    __metadata("design:paramtypes", [String, String, Number, Number, Object, Object, Object])
], PerspectiveCameraObject);
export { PerspectiveCameraObject };
//# sourceMappingURL=PerspectiveCameraObject.js.map